import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import {OrganizationCard} from "./organizationCard";
import {
  ACTIONS_LIST,
  LIST_HEADERS,
  PERMS_FOR_ACTIONS,
} from "./organizationTable.constants";
import {useOrganizationSearchOptions} from "./useOrganizationSearchOptions";
import {useOrganizationTableActions} from "./useOrganizationTableActions";
import {useOrganizationTableData} from "./useOrganizationTableData";

const OrganizationTable = () => {
  const {handleSearch, organizations, paginationConfig, totalCount} =
    useOrganizationTableData();
  const {handleActionSelection} = useOrganizationTableActions();
  const {searchOptions} = useOrganizationSearchOptions();

  return (
    <Fragment>
      <ListView
        cardContent={OrganizationCard}
        listItems={organizations}
        listHeaders={LIST_HEADERS}
        totalCount={totalCount}
        withPagination={paginationConfig}
        onSelectAction={handleActionSelection}
        withActions
        actionsList={ACTIONS_LIST}
        permsForActions={PERMS_FOR_ACTIONS}
        withSearchQuery={true}
        searchPlaceHolder={"Filter Organizations"}
        searchOptions={searchOptions}
        handleSearch={handleSearch}
      />
    </Fragment>
  );
};

export default OrganizationTable;
